//主页面
const index = (r) => require.ensure([], () => r(require('@/components/home.vue')), 'index');

//信用额度申请单列表
const applicationCreditList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/applicationCredit/list.vue')),
    'applicationCreditList'
  );

//信用额度申请单新增
const applicationCreditAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/applicationCredit/add.vue')),
    'applicationCreditAdd'
  );

//信用额度申请单详情
const applicationCreditDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/applicationCredit/detail.vue')),
    'applicationCreditDetail'
  );

//信用额度申请单修改
const applicationCreditEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/applicationCredit/edit.vue')),
    'applicationCreditEdit'
  );

//设备抵押列表
const equipmentMortgageList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/equipmentMortgage/list.vue')),
    'equipmentMortgageList'
  );

//设备抵押新增
const equipmentMortgageAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/equipmentMortgage/add.vue')),
    'equipmentMortgageAdd'
  );

//设备抵押修改
const equipmentMortgageEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/equipmentMortgage/edit.vue')),
    'equipmentMortgageEdit'
  );

//信用额度列表
const creditList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/credit/list.vue')),
    'creditList'
  );

//信用额度新增
const creditAdd = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/credit/add.vue')),
    'creditAdd'
  );

//信用额度新增
const creditEdit = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/credit/edit.vue')),
    'creditEdit'
  );

//信用额度统计
const creditStatisticsList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/list.vue')),
    'creditStatisticsList'
  );

//信用额度统计详情
const creditStatisticsDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/detail.vue')),
    'creditStatisticsDetail'
  );
//信用额度部分字段统计详情
const creditStatisticsDetailColumns = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/detailSomeColumns.vue')),
    'creditStatisticsDetailColumns'
  );

//信用额度统计-公式类型
const formulaType = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/formulaType.vue')),
    'formulaType'
  );

//信用额度统计-因子
const calculationFactor = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/calculationFactor.vue')),
    'calculationFactor'
  );

//信用额度统计-计算公式
const formula = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/formula.vue')),
    'formula'
  );

//可放货额度统计列表
const orderLadingLimitList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/orderLadingLimit/list.vue')),
    'orderLadingLimitList'
  );

//可放货额度币种明细
const orderLadingLimitCurrencyList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/orderLadingLimit/listCurrency.vue')),
    'orderLadingLimitCurrencyList'
  );

//可放货额度单据明细详情
const orderLadingLimitDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/orderLadingLimit/listDetail.vue')),
    'orderLadingLimitDetail'
  );
//已签未付款订单详情
const hnYfKqAmountOrderList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/statistics/hnYfKqAmountOrderList.vue')),
    'hnYfKqAmountOrderList'
  );

//管控单据配置列表
const controlBillList = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/controlBill/list.vue')),
    'controlBillList'
  );
//管控单据配置列表
const controlBillDetail = (r) =>
  require.ensure(
    [],
    () => r(require('@/pages/purchaseSalesCenter/credit/controlBill/edit.vue')),
    'controlBillDetail'
  );
const creditRouter = {
  path: '/credit',
  component: index,
  children: [
    {
      path: 'formulaType',
      name: 'formulaType',
      component: formulaType,
      meta: {
        keepAlive: true,
        title: '信用额度公式类型配置',
      },
    },
    {
      path: 'calculationFactor',
      name: 'calculationFactor',
      component: calculationFactor,
      meta: {
        keepAlive: true,
        title: '信用额度因子配置',
      },
    },
    {
      path: 'equipmentMortgageList',
      name: 'equipmentMortgageList',
      component: equipmentMortgageList,
      meta: {
        keepAlive: true,
        title: '设备抵押申请单列表',
      },
    },
    {
      path: 'equipmentMortgageAdd',
      name: 'equipmentMortgageAdd',
      component: equipmentMortgageAdd,
      meta: {
        keepAlive: true,
        title: '设备抵押申请单新增',
      },
    },
    {
      path: 'equipmentMortgageEdit',
      name: 'equipmentMortgageEdit',
      component: equipmentMortgageEdit,
      meta: {
        keepAlive: true,
        title: '设备抵押申请单修改',
      },
    },
    {
      path: 'formula',
      name: 'formula',
      component: formula,
      meta: {
        keepAlive: true,
        title: '信用额度计算公式配置',
      },
    },
    {
      path: 'applicationList',
      name: 'applicationCreditList',
      component: applicationCreditList,
      meta: {
        keepAlive: true,
        title: '信用额度申请单列表',
      },
    },
    {
      path: 'applicationAdd',
      name: 'applicationCreditAdd',
      component: applicationCreditAdd,
      meta: {
        keepAlive: true,
        title: '信用额度申请单新增',
      },
    },
    {
      path: 'applicationDetail',
      name: 'applicationCreditDetail',
      component: applicationCreditDetail,
      meta: {
        keepAlive: true,
        title: '信用额度申请单详情',
      },
    },
    {
      path: 'applicationCreditEdit',
      name: 'applicationCreditEdit',
      component: applicationCreditEdit,
      meta: {
        keepAlive: true,
        title: '信用额度申请单修改',
      },
    },
    {
      path: 'creditList',
      name: 'creditList',
      component: creditList,
      meta: {
        keepAlive: true,
        title: '信用额度列表',
      },
    },
    {
      path: 'creditAdd',
      name: 'creditAdd',
      component: creditAdd,
      meta: {
        keepAlive: true,
        title: '信用额度新增',
      },
    },
    {
      path: 'creditEdit',
      name: 'creditEdit',
      component: creditEdit,
      meta: {
        keepAlive: true,
        title: '信用额度修改',
      },
    },
    {
      path: 'statisticsList',
      name: 'creditStatisticsList',
      component: creditStatisticsList,
      meta: {
        keepAlive: true,
        title: '信用额度统计',
      },
    },
    {
      path: 'statisticsDetail',
      name: 'creditStatisticsDetail',
      component: creditStatisticsDetail,
      meta: {
        keepAlive: true,
        title: '信用额度分析',
      },
    },
    {
      path: 'statisticsDetailColumns',
      name: 'creditStatisticsDetailColumns',
      component: creditStatisticsDetailColumns,
      meta: {
        keepAlive: true,
        title: '信用额度分析',
      },
    },

    {
      path: 'orderLadingLimitList',
      name: 'orderLadingLimitList',
      component: orderLadingLimitList,
      meta: {
        keepAlive: true,
        title: '可放货额度统计列表',
      },
    },
    {
      path: 'currencyList',
      name: 'orderLadingLimitCurrencyList',
      component: orderLadingLimitCurrencyList,
      meta: {
        keepAlive: true,
        title: '可放货额度币种明细',
      },
    },
    {
      path: 'orderLadingLimitDetail',
      name: 'orderLadingLimitDetail',
      component: orderLadingLimitDetail,
      meta: {
        keepAlive: true,
        title: '可放货额度单据明细详情',
      },
    },
    {
      path: 'hnYfKqAmountOrderList',
      name: 'hnYfKqAmountOrderList',
      component: hnYfKqAmountOrderList,
      meta: {
        keepAlive: true,
        title: '已签未付款订单详情',
      },
    },
    {
      path: 'controlBillList',
      name: 'controlBillList',
      component: controlBillList,
      meta: {
        keepAlive: true,
        title: '管控单据配置',
      },
    },
    {
      path: 'controlBillDetail',
      name: 'controlBillDetail',
      component: controlBillDetail,
      meta: {
        keepAlive: true,
        title: '管控单据编辑',
      },
    },
  ],
};
export default creditRouter;
